'use client'

import { useTranslations } from 'next-intl'
import { useGetAllBlogsQuery } from '@/api/blogs/get-all-blogs'
import BlogsAndRestaurantsSlider from '../blog/slider/blogs-and-restaurants-slider'

export default function HomeBlogSlider() {
    const t = useTranslations()
    const { data: blogs, isLoading } = useGetAllBlogsQuery()

    return (
        <div className="w-full">
            <BlogsAndRestaurantsSlider
                title={t('blog.slider.home')}
                blogs={blogs?.data?.slice(0, 5)}
                isLoading={isLoading}
            />
        </div>
    )
}
